
import React, { useEffect, useState } from 'react';
import { host_url } from '../../App'; // Import host_url
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import SuccessModal from '../../SuccessModal';
import './FreizeitVerwaltung.css';
import '../Freizeit.css';

function FreizeitVerwaltung() {
  const [angebote, setAngebote] = useState([]);
  const [selectedAngebotId, setSelectedAngebotId] = useState('');
  const [selectedAngebot, setSelectedAngebot] = useState(null);
  const [successMsg, setSuccessMsg] = useState('');
  const [formData, setFormData] = useState({
    Name: '',
    Beschreibung: '',
    Kosten: '',
    X: '',
    Y: ''
  });

  useEffect(() => {
    fetch(`${host_url}/freizeitangebote`)
      .then(response => response.json())
      .then(data => setAngebote(data));
  }, []);

  const handleAngebotSelect = (e) => {
    const angebotID = Number(e.target.value);
    setSelectedAngebotId(angebotID);
    const angebot = angebote.find(a => a.ID === angebotID);
    if (angebot) {
      setSelectedAngebot(angebot);
      setFormData({
        Name: angebot.Name,
        Beschreibung: angebot.Beschreibung,
        Kosten: angebot.Kosten,
        X: angebot.X,
        Y: angebot.Y
      });
    } else {
      setSelectedAngebot(null);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    fetch(`${host_url}/freizeitangebote`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ...formData, ID: selectedAngebotId })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        setSuccessMsg('Freizeitangebot erfolgreich aktualisiert');
      } else {
        alert('Fehler beim Aktualisieren des Freizeitangebots');
      }
    });
  };

  const handleDeleteAngebot = () => {
    if (!selectedAngebotId) {
      alert('Bitte zuerst ein Freizeitangebot auswählen.');
      return;
    }

    if (!window.confirm(`Möchtest du das Freizeitangebot "${formData.Name}" wirklich löschen?`)) {
      return;
    }

    fetch(`${host_url}/freizeitangebote/${selectedAngebotId}`, {
      method: 'DELETE',
    })
      .then(async response => {
        let data = null;
        try {
          data = await response.json();
        } catch {
          // Wenn keine gültige JSON-Antwort kam, behandeln wir das als Fehler
        }
        if (!response.ok) {
          throw new Error(data?.message || data?.error || 'Unbekannter Fehler');
        }
        return data;
      })
      .then(data => {
        if (data?.success) {
          setSuccessMsg('Freizeitangebot erfolgreich gelöscht');
          fetch(`${host_url}/freizeitangebote`)
            .then(response => response.json())
            .then(updatedData => {
              setAngebote(updatedData);
              setSelectedAngebotId('');
              setSelectedAngebot(null);
              setFormData({ Name: '', Beschreibung: '', Kosten: '', X: '', Y: '' });
            });
        } else {
          alert('Fehler beim Löschen des Freizeitangebots: ' + (data?.message || data?.error || 'Unbekannter Fehler'));
        }
      })
      .catch(err =>
        alert('Netzwerkfehler oder Server nicht erreichbar beim Löschen des Freizeitangebots: ' + err.message)
      );
  };

  return (
    <KernteamLayout>
      <div className="container">
        <BackArrow to="/freizeit" />
        <h1 className="section-title">Freizeitangebot bearbeiten</h1>
        <main>
          <div className="angebot-select">
            <h3>Freizeitangebot</h3>
            <div className={`dropdown-wrapper ${selectedAngebot ? 'filled' : ''}`}>
              <select onChange={handleAngebotSelect} value={selectedAngebotId}>
                <option value="" disabled>Wähle ein Freizeitangebot</option>
                {angebote.map(angebot => (
                  <option key={angebot.ID} value={angebot.ID}>{angebot.Name}</option>
                ))}
              </select>
              <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
            </div>
          </div>
          {selectedAngebot && (
            <div className="angebot-form">
              <div className="form-group">
                <label>
                  Name
                  <input type="text" name="Name" value={formData.Name} onChange={handleChange} />
                </label>
              </div>
              <div className="form-group">
                <label>
                  Beschreibung
                  <textarea name="Beschreibung" value={formData.Beschreibung} onChange={handleChange} />
                </label>
              </div>
              <div className="form-group">
                <label>
                  Kosten in Stormark
                  <input type="number" name="Kosten" value={formData.Kosten} onChange={handleChange} />
                </label>
              </div>
              <div className="fv-map-container">
                <a
                  href={
                    selectedAngebotId
                      ? `/freizeitmarkieren?angebotID=${selectedAngebotId}`
                      : '/freizeitmarkieren'
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fv-map-link"
                >
                  <span className="material-symbols-outlined fv-map-icon">add_location</span>
                  <span className="fv-map-label">Auf Karte markieren</span>
                </a>
              </div>
              <div className="actions">
                <button onClick={handleSubmit}>Änderungen speichern</button>
                <div className="delete-link" onClick={handleDeleteAngebot}>
                  <span className="material-symbols-outlined delete-icon">delete</span>
                  <span className="delete-label">Freizeitangebot löschen</span>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
      <SuccessModal message={successMsg} onClose={() => setSuccessMsg('')} />
    </KernteamLayout>
  );
}

export default FreizeitVerwaltung;